// Shared pagination control for the server-paged grids (Legacy Spark Chats,
// Discovery Calls). Shows the current window and Prev/Next buttons.

export default function Pager({
  page,
  size,
  total,
  onPrev,
  onNext,
}: {
  page: number;
  size: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
}) {
  const from = total === 0 ? 0 : (page - 1) * size + 1;
  const to = Math.min(page * size, total);
  const canPrev = page > 1;
  const canNext = page * size < total;
  return (
    <div className="flex items-center justify-between gap-3 text-sm text-brand-sage">
      <span>
        {from}–{to} of {total}
      </span>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={onPrev}
          disabled={!canPrev}
          className="rounded-md border border-brand-sage/40 bg-white px-3 py-1.5 font-bold text-brand-forest transition hover:border-brand-lime hover:text-brand-lime-700 disabled:cursor-not-allowed disabled:opacity-40"
        >
          ‹ Prev
        </button>
        <button
          type="button"
          onClick={onNext}
          disabled={!canNext}
          className="rounded-md border border-brand-sage/40 bg-white px-3 py-1.5 font-bold text-brand-forest transition hover:border-brand-lime hover:text-brand-lime-700 disabled:cursor-not-allowed disabled:opacity-40"
        >
          Next ›
        </button>
      </div>
    </div>
  );
}